import { useEffect,useRef, useState } from 'react';
import { AutoSizer,List, WindowScroller } from 'react-virtualized';

import usePreferredLocale from '@/hooks/usePreferredLocale';
import useScreenSize from '@/hooks/useScreenSize';
import { getCategoryDisplayEntries } from '@/utils/categoryTaxonomy';

import CategoryItem from './CategoryItem';

import './styles/Emotion.css';

export default function Emotion({ query, setQuery }) {
  const [scrollElement, setScrollElement] = useState(null);
  const locale = usePreferredLocale();
  const items = getCategoryDisplayEntries('emotion', locale);
  const scrollElementRef = useRef();
  const screenSize = useScreenSize();
  const listRef = useRef();

  useEffect(()=>{
    setScrollElement(scrollElementRef.current);
  }, []); 

  useEffect(()=>{
    listRef.current?.recomputeRowHeights();
  }, [screenSize]);

  function selectItem(item) {
    if(query.emotion) {
      setQuery({ ...query, emotion: [...query.emotion, item.value] });
    } else {
      setQuery({ ...query, emotion: [item.value] });
    }
  }

  function removeItem(item) {
    setQuery({ ...query, emotion: query.emotion.filter(emotion => emotion !== item.value) });
  }

  return (
    <>
      <div className="search-filters-content-emotion-virtual-list" ref={scrollElementRef}>
        {scrollElement && <WindowScroller scrollElement={scrollElement}>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer disableHeight>
              {({ width }) => (
                <List
                  autoHeight
                  width={width ? width : 0.1}
                  height={height ? height : 0} 
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  rowCount={items.length}
                  rowHeight={50}
                  scrollTop={scrollTop}
                  overscanRowCount={5}
                  ref={listRef}
                  rowRenderer={({ index, key, style }) => (
                    <div key={key} style={style}>
                      <CategoryItem 
                        displayText={items[index].label}
                        isSelected={query.emotion?.some(emotion => emotion === items[index].value)}
                        selectItem={()=>selectItem(items[index])}
                        removeItem={()=>removeItem(items[index])}
                      />
                    </div>
                  )}
                />
              )}
            </AutoSizer>
          )}
        </WindowScroller>}
      </div>
    </>
  );
}
